import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, FileTextIcon, HomeIcon } from 'lucide-react';
interface CompletionScreenProps {
  firstName: string;
  onReset: () => void;
}
export function CompletionScreen({
  firstName,
  onReset
}: CompletionScreenProps) {
  const handlePrint = () => {
    window.print();
  };
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} className="min-h-screen bg-[#f8f9fa] flex items-center justify-center p-4 print:hidden" data-id="element-7">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-xl p-8 md:p-12 text-center border border-gray-100" data-id="element-8">
        <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-9">
          <CheckCircleIcon className="h-10 w-10 text-[#8DC63F]" data-id="element-10" />
        </div>

        <h1 className="text-3xl font-bold text-[#1a1a2e] mb-4" data-id="element-11">
          Vielen Dank, {firstName}!
        </h1>

        <p className="text-[#4a4a5a] mb-8 text-lg" data-id="element-12">
          Sie haben die Arbeitsunterweisung erfolgreich abgeschlossen. Ihre
          Bestätigung wurde erfasst.
        </p>

        <div className="bg-gray-50 rounded-xl p-6 mb-8 border border-gray-200 text-left" data-id="element-13">
          <h3 className="font-semibold text-[#1a1a2e] mb-2" data-id="element-14">
            Zusammenfassung:
          </h3>
          <ul className="space-y-2 text-sm text-[#4a4a5a]" data-id="element-15">
            <li className="flex items-center" data-id="element-16">
              <CheckCircleIcon className="h-4 w-4 text-[#8DC63F] mr-2" data-id="element-17" />
              Modul 1: Gefährdungsbeurteilung – Büroarbeitsplatz
            </li>
            <li className="flex items-center" data-id="element-18">
              <CheckCircleIcon className="h-4 w-4 text-[#8DC63F] mr-2" data-id="element-19" />
              Alle Abschnitte gelesen und verstanden
            </li>
            <li className="flex items-center" data-id="element-20">
              <CheckCircleIcon className="h-4 w-4 text-[#8DC63F] mr-2" data-id="element-21" />
              Rechtsgültig unterschrieben
            </li>
          </ul>
        </div>

        <div className="space-y-4" data-id="element-22">
          <button onClick={handlePrint} className="w-full flex items-center justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-white bg-[#8DC63F] hover:bg-[#7ab036] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#8DC63F] transition-colors font-medium" data-id="element-23">
            <FileTextIcon className="mr-2 h-5 w-5" data-id="element-24" />
            Als PDF herunterladen / Drucken
          </button>

          <button onClick={onReset} className="w-full flex items-center justify-center py-3 px-4 border border-gray-300 rounded-lg shadow-sm text-[#4a4a5a] bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#8DC63F] transition-colors font-medium" data-id="element-25">
            <HomeIcon className="mr-2 h-5 w-5" data-id="element-26" />
            Zurück zum Start
          </button>
        </div>
      </div>
    </motion.div>;
}